import AccessDenied from '@/views/access/views/AccessDenied.vue';

export default [
  {
    path: '/access-denied/',
    component: AccessDenied   
  }
];